var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgLinkBlue = function SvgLinkBlue(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.575 1a.8.8 0 0 1 .8-.8h4.875a.8.8 0 0 1 .8.8v4.875a.8.8 0 0 1-1.6 0V2.931l-6.76 6.76a.8.8 0 0 1-1.13-1.132L12.318 1.8H9.375a.8.8 0 0 1-.8-.8ZM1.16 2.535a2.425 2.425 0 0 1 1.715-.71h3.25a.8.8 0 1 1 0 1.6h-3.25a.825.825 0 0 0-.825.825v8.125a.825.825 0 0 0 .825.825H11a.825.825 0 0 0 .825-.825v-3.25a.8.8 0 1 1 1.6 0v3.25A2.425 2.425 0 0 1 11 14.8H2.875A2.425 2.425 0 0 1 .45 12.375V4.25c0-.643.255-1.26.71-1.715Z",
    fill: "#ECE8E3"
  })));
};
export default SvgLinkBlue;